import * as React from "react";
import { useEffect, useState } from "react";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import Select, { components } from "react-select";
import { axiosClient } from "../../../../Constant/apiConstant";
import { lastLoginTrackAction } from "../../Actions/CommonActions";
import { checkRolesAccess } from "../../CommonComponents/Common";
import { saveSelectedAccount } from "../../Store/Account/Account.action";
import { customStyles } from "../../../../assets/MUIStyles/sidebarMenu";
import { CampaignType } from "../../ProjectSection/CampaignSection/Store/Campaign.type";
import { setEncryptedItem } from "../../../../utils/localStorageHelper";
import { lighten, useTheme } from "@mui/material";

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}
const drawerWidth = 265;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
  boxShadow: "none",
}));

const settings = [
  { id: "access", name: "Access Manager", to: "/account/access" },
  // {
  //   id: "voice-cloning",
  //   name: "Voice Cloning",
  //   to: "/account/voice-cloning",
  // },
  { id: "history", name: "Account History", to: "/account/history" },
  { id: "integration", name: "Integration", to: "/account/integrations" },
];
const admin = [
  {
    id: "admin",
    name: "Admin Dashboard",
    to: "/account/admin",
    subRoutes: { to: "/account/recharge" },
  },
  {
    id: "topup",
    name: "Topup Account (Sales)",
    to: "/account/account-topup",
  },
];

const Topbar = ({ open, styles, showSettings, showAdminControls }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const history = useHistory();
  const { pathname } = useLocation();
  const projectId = pathname.split("/")[3];
  const brandColor = theme.custom.brandColor;
  const reducer = useSelector((reducer: any) => reducer);
  const {
    AccountReducer: {
      userDetails: { accounts, _id, role },
      selectedAccount,
    },
    ProjectReducer: { projectList },
  } = reducer;

  const [activeSetting, setActiveSetting] = useState("access");
  const [activeAdmin, setActiveAdmin] = useState("admin");
  const [isProjectMenuOpen, setIsProjectMenuOpen] = useState(false);
  const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);

  useEffect(() => {
    setIsProjectMenuOpen(false);
    setIsAccountMenuOpen(false);

    const getCurrentIndex: any = admin.find(
      (item) => item?.to === pathname || item?.subRoutes?.to === pathname
    )?.id;
    if (getCurrentIndex) {
      setActiveAdmin(getCurrentIndex);
    }
    const currentSettingsIndex: any = settings.find(
      (item) => item?.to === pathname
    )?.id;
    setActiveSetting(currentSettingsIndex);
  }, [pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const target = event.target as Element;
      const isInsideSelect =
        target.closest(".project-select") ||
        target.closest('[class*="select__"]') ||
        target.closest('[class*="Select"]');

      if (!isInsideSelect) {
        setIsProjectMenuOpen(false);
        setIsAccountMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClick = (id) => {
    setActiveSetting(id);
    setActiveAdmin(id);
  };

  const adminItems = (role) => {
    return admin.filter((item) => {
      if ((role === "sales" || role === "super_admin") && item.id === "topup") {
        return true;
      }
      if ((role === "admin" || role === "super_admin") && item.id === "admin") {
        return true;
      }
      return false;
    });
  };

  const changeAccount = async (account) => {
    const lastLoginObj = {
      accountUrl: account?.accountUrl,
      userId: _id,
      accountId: account?._id,
      track: true,
    };
    const res1: any = await dispatch(lastLoginTrackAction(lastLoginObj));
    await dispatch(saveSelectedAccount(account));
    if (res1) {
      const goTo = checkRolesAccess(res1);
      if (goTo === "dashboard") {
        history.push("/account/dashboard");
      }
      if (goTo === "project") {
        history.push("/account/projects");
      }
      await dispatch({
        type: CampaignType.GET_CALL_HISTORY_DATA,
        payload: { data: [] },
      });
    }
    localStorage.removeItem("visitedItems");
  };

  const changeProject = async (project) => {
    localStorage.removeItem("starred");
    localStorage.removeItem("campaignSearchText");
    localStorage.removeItem("campaignpageIndex");
    localStorage.removeItem("campaignRunpageIndex");
    localStorage.removeItem("campaignRunDetailsIndex");
    localStorage.removeItem("searchTextAud");
    localStorage.removeItem("email");
    localStorage.removeItem("sms");
    axiosClient.defaults.headers.common["projectId"] = project?._id;
    setEncryptedItem("projectId", project._id);
    history.push(`/account/project/${project?._id}/agents`);
    // if (project?.botPlatform?.includes("llm")) {
    //   history.push(`/account/project/${project?._id}/agents`);
    // } else {
    //   history.push(`/account/project/${project?._id}/campaigns`);
    // }
  };

  return (
    <>
      <AppBar
        sx={{ ...styles.bg, "&.MuiPaper-root": { background: "#181818" } }}
        position="fixed"
        open={open}
      >
        <Toolbar className="flex-between-only">
          <Box
            className="flex-between-only"
            sx={{
              width: "150px",
            }}
          >
            <Box sx={{ ...styles.settingsBox }}>
              {showSettings &&
                settings.map((item) => (
                  <Box
                    key={item?.id}
                    style={{
                      ...styles.settingsNav,
                      backgroundColor: `${
                        activeSetting === item?.id ? "#111111" : "transparent"
                      }`,
                    }}
                    onClick={() => {
                      history.push(item?.to);
                      handleClick(item?.id);
                    }}
                  >
                    <p
                      className="font-13-500"
                      style={{
                        margin: 1,
                        textAlign: "center",
                        color: `${
                          activeSetting === item?.id ? "#FFFFFF" : "#9E9FA1"
                        }`,
                      }}
                    >
                      {item.name}
                    </p>
                    {activeSetting === item?.id && (
                      <Box
                        sx={{
                          height: "5px",
                          width: "100%",
                          background: `${
                            activeSetting === item?.id
                              ? lighten(brandColor, 0.2)
                              : "transparent"
                          }`,
                          borderTopLeftRadius: "6px",
                          borderTopRightRadius: "6px",
                        }}
                      ></Box>
                    )}
                  </Box>
                ))}
            </Box>
            <Box sx={{ ...styles.settingsBox }}>
              {showAdminControls &&
                adminItems(role).map((item) => (
                  <Box
                    key={item?.id}
                    style={{
                      ...styles.settingsNav,
                      width: "150px",
                      backgroundColor: `${
                        activeAdmin === item?.id ? "#111111" : "transparent"
                      }`,
                    }}
                    onClick={() => {
                      history.push(item?.to);
                      handleClick(item?.id);
                    }}
                  >
                    <p
                      className="font-13-500"
                      style={{
                        margin: 1,
                        textAlign: "center",
                        color: `${
                          activeAdmin === item?.id ? "#FFFFFF" : "#9E9FA1"
                        }`,
                      }}
                    >
                      {item.name}
                    </p>
                    {activeAdmin === item?.id && (
                      <Box
                        sx={{
                          height: "5px",
                          width: "100%",
                          background: `${
                            activeAdmin === item?.id
                              ? lighten(brandColor, 0.2)
                              : "transparent"
                          }`,
                          borderTopLeftRadius: "6px",
                          borderTopRightRadius: "6px",
                        }}
                      ></Box>
                    )}
                  </Box>
                ))}
            </Box>
          </Box>
          <Box className="flex-align-center" sx={{ gap: 1 }}>
            {!showSettings && (
              <Typography className="font-13-600-lightgrey">
                {projectId ? "Current Project" : "Current Account"}
              </Typography>
            )}
            {projectId ? (
              <Select
                styles={customStyles}
                maxMenuHeight={180}
                className="basic-single project-select"
                classNamePrefix="select"
                value={projectList?.find(
                  (project) => project?._id === projectId
                )}
                isDisabled={false}
                isSearchable={true}
                options={projectList}
                getOptionLabel={(e: any) => e?.projectName}
                getOptionValue={(e: any) => e?._id}
                onChange={(e) => {
                  changeProject(e);
                  setIsProjectMenuOpen(false);
                }}
                onMenuOpen={() => setIsProjectMenuOpen(true)}
                onMenuClose={() => setIsProjectMenuOpen(false)}
                menuIsOpen={isProjectMenuOpen}
                placeholder="Select Project"
                components={{
                  Input: (props) => (
                    <components.Input {...props} maxLength={30} />
                  ),
                }}
              />
            ) : (
              <Select
                styles={customStyles}
                maxMenuHeight={180}
                className="basic-single project-select"
                classNamePrefix="select"
                value={accounts?.find(
                  (project) =>
                    project.accountName === selectedAccount?.accountName
                )}
                isDisabled={false}
                isSearchable={true}
                options={accounts}
                getOptionLabel={(e: any) => e?.accountName}
                getOptionValue={(e: any) => e?._id}
                onChange={(e) => {
                  changeAccount(e);
                  setIsAccountMenuOpen(false);
                }}
                onMenuOpen={() => setIsAccountMenuOpen(true)}
                onMenuClose={() => setIsAccountMenuOpen(false)}
                menuIsOpen={isAccountMenuOpen}
                placeholder="Select Account"
                components={{
                  Input: (props) => (
                    <components.Input {...props} maxLength={30} />
                  ),
                }}
              />
            )}
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Topbar;
